import React from 'react';
import { Plus, Trash2, Boxes } from 'lucide-react';
import { Button } from './ui/button';
import { Input } from './ui/input';

const newId = () => Math.random().toString(36).slice(2, 10);

// Admin: packs sold at a better price (e.g. "Carton de 12")
const PackEditor = ({ packs, unitPrice, onChange }) => {
  const update = (idx, key, value) => onChange(packs.map((p, i) => (i === idx ? { ...p, [key]: value } : p)));
  const remove = (idx) => onChange(packs.filter((_, i) => i !== idx));
  const add = () => onChange([...packs, { id: newId(), label: 'Carton de 12', units: 12, price: unitPrice ? (unitPrice * 12 * 0.9).toFixed(2) : '' }]);
  const price = parseFloat(unitPrice) || 0;

  return (
    <div data-testid="pack-editor">
      <div className="flex items-center justify-between mb-2">
        <div>
          <h3 className="font-semibold text-gray-900 flex items-center gap-2"><Boxes size={18} className="text-orange-500" /> Conditionnements (packs)</h3>
          <p className="text-xs text-gray-500">Vendez aussi par lot ou carton à un meilleur tarif. Le stock est toujours compté en unités (1 carton de 12 = 12 unités).</p>
        </div>
        <Button type="button" variant="outline" size="sm" onClick={add} data-testid="pack-add"><Plus size={14} className="mr-1" /> Ajouter un pack</Button>
      </div>
      {packs.length > 0 && (
        <div className="space-y-2">
          {packs.map((p, idx) => {
            const units = parseInt(p.units, 10) || 0;
            const pp = parseFloat(p.price) || 0;
            const saving = price && units && pp ? Math.round((1 - pp / (price * units)) * 100) : null;
            return (
              <div key={p.id} className="grid grid-cols-12 gap-2 items-end bg-gray-50 border border-gray-200 rounded-lg p-3" data-testid={`pack-row-${idx}`}>
                <div className="col-span-12 sm:col-span-5">
                  <label className="block text-xs font-medium text-gray-600 mb-1">Libellé</label>
                  <Input data-testid={`pack-label-${idx}`} value={p.label} onChange={(e) => update(idx, 'label', e.target.value)} placeholder="Carton de 12" />
                </div>
                <div className="col-span-4 sm:col-span-2">
                  <label className="block text-xs font-medium text-gray-600 mb-1">Unités</label>
                  <Input data-testid={`pack-units-${idx}`} type="number" min="2" step="1" value={p.units} onChange={(e) => update(idx, 'units', e.target.value)} />
                </div>
                <div className="col-span-5 sm:col-span-3">
                  <label className="block text-xs font-medium text-gray-600 mb-1">Prix TTC du pack (€)</label>
                  <Input data-testid={`pack-price-${idx}`} type="number" min="0" step="0.01" value={p.price} onChange={(e) => update(idx, 'price', e.target.value)} />
                </div>
                <div className="col-span-3 sm:col-span-2 flex items-center justify-between gap-1 h-10">
                  <span className={`text-xs font-semibold ${saving > 0 ? 'text-green-700' : saving < 0 ? 'text-red-600' : 'text-gray-400'}`} data-testid={`pack-saving-${idx}`}>
                    {saving === null ? '—' : `${saving > 0 ? '−' : '+'}${Math.abs(saving)} %`}
                  </span>
                  <button type="button" data-testid={`pack-remove-${idx}`} onClick={() => remove(idx)} className="p-2 text-red-500 hover:bg-red-50 rounded"><Trash2 size={16} /></button>
                </div>
                {units > 0 && pp > 0 && <p className="col-span-12 text-[11px] text-gray-500">Soit {(pp / units).toFixed(2)} € / unité{price ? ` au lieu de ${price.toFixed(2)} €` : ''}</p>}
              </div>
            );
          })}
        </div>
      )}
    </div>
  );
};

export default PackEditor;
